import React, { useState } from 'react'
import './About.css';

function About({className}) {

    const [activeMenu, setActiveMenu] = useState(0);

    const Menus = ['Menu 1', 'Menu 2', 'Menu 3', 'Menu 3'];

    return (
        <div className={className}>
            <div className="about-menu">
                {
                    Menus.map((value, index) => (
                        <div key={index}>
                            <p onClick={() => setActiveMenu(index)} className={activeMenu === index ? "active": ""}>{value}</p>
                        </div>
                    ))
                }
            </div>
            <div className="about-data">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint voluptas veniam harum rem magnam sit iste! Accusantium quibusdam corporis accusamus blanditiis laborum repellendus! Maxime corrupti deserunt autem, a esse ullam!
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint voluptas veniam harum rem magnam sit iste! Accusantium quibusdam corporis accusamus blanditiis laborum repellendus! Maxime corrupti deserunt autem, a esse ullam!
            </div>
        </div>
    )
}

export default About
